import * as React from 'react';
import './TemplateItem.scss';
import { ITemplateItemProps } from './ITemplateItem';

const TemplateItem = (props: ITemplateItemProps) => {
    return (
        <div className={`d-flex align-items-center cursor-pointer bg-white p-3 gap-2 ${props.className}`} style={props.style} onClick={props.onClick}>
            <img src={props.imageUrl} className='img-template' />
            <span>{props.name}</span>
        </div>
    );
};

export default TemplateItem;
